/**
 * @format
 * @Description: 资源管理状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';

const CDN_BASE = 'assets';
useStrict(true);
class ApplicationResourcesMod {
  @observable
  tabsVal = '1';

  @observable
  formVersion = 0;

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }
  saveFormBeforeRequest = data => {
    return data;
  };
}

// ES6单例写法
export default new ApplicationResourcesMod();



// WEBPACK FOOTER //
// ./src/pages/ResourceManage/ApplicationResources/ApplicationResourcesMod.js